<script>
  import { alert } from 'vue-strap';
  import Importacao from './FormListaImportacao.vue';

  export default {
    components: { 
      alert, 
      Importacao,
    },
    props: {
      itensSolicitacaoImportacao: Array,
      relatorio: {
        type: Boolean,
        required: false,
        default: false
      },
      solicitacao: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao()
      }
    },
    methods: {
      deletarItem(indice) {
        this.itensSolicitacaoImportacao.splice(indice, 1);
      },
      editarItem(indice) {
        this.$emit('editarItem', indice);
      }

    },
    computed: {
      total: function() {
        return this.itensSolicitacaoImportacao.reduce((somatorio, item) => {
          const valorEstimado = this.$options.filters.formatarNumero(item.valorEstimado, true);
          const quantidade = this.$options.filters.formatarNumero(item.quantidade, true);

          return somatorio + (quantidade * valorEstimado);
        }, 0);
      },
      totalReal: function() {
        return this.itensSolicitacaoImportacao.reduce((somatorio, item) => {
          const valorEstimado = this.$options.filters.formatarNumero(item.valorEstimado, true);
          const quantidade = this.$options.filters.formatarNumero(item.quantidade, true);
          let cotacao = this.$options.filters.formatarNumero(this.solicitacao.cotacaoEstimada, true, true,5); 

          if (!cotacao)
            cotacao = 1.0;

          return somatorio + (quantidade * valorEstimado * cotacao);
        }, 0);
      },
        retornaSimboloMoeda() {
            if (!this.solicitacao.idMoeda)
                return '';

            if (this.solicitacao.importacaoMoeda.simbolo)
                return '(' + this.solicitacao.importacaoMoeda.simbolo + ')';

            return '';
        }
    }
  }
</script>

<template>

  <div>
    <alert type="warning" v-if="itensSolicitacaoImportacao.length === 0">
      <i class="fa fa-warning"></i> Nenhum item adicionado.
    </alert>

    <div class="bs-callout bs-callout-info no-margin-top" v-for="(item, index) in itensSolicitacaoImportacao">
      <h4>
        Item #{{ index + 1 }}

        <button type="button"
                class="btn btn-sm btn-warning btn-delete-item"
                title="Editar item"
                @click="editarItem(index)"
                style="right: 73px;"
                v-if="!relatorio">
            <i class="fa fa-pencil"></i>
        </button>

        <button 
                type="button" 
                class="btn btn-sm btn-danger btn-delete-item"
                title="Excluir item" 
                @click="deletarItem(index)"
                v-if="!relatorio">
          <i class="fa fa-trash"></i>
        </button>
      </h4>

      <importacao
          :item="item"
          :solicitacao="solicitacao"
          :relatorio="relatorio">
      </importacao>
    </div>

    <div class="bs-callout bs-callout-primary" v-if="configuracao.utilizarValorEstimadoImportacao">
      <h4>Valor total {{retornaSimboloMoeda}}: {{ total | formatarNumero }}</h4><br />
      <h4>Valor total estimado (R$): {{ totalReal | formatarNumero }}</h4>
    </div>
  </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-importacao-projeto/componentes/compartilhado/FormListaItens.vue